import Vue from 'vue'
import './pollyfills'
import VueRouter from 'vue-router'
import VueNotify from 'vue-notifyjs'
import VeeValidate, { Validator } from 'vee-validate'
import lang from 'element-ui/lib/locale/lang/ru-RU'
import langValidateRu from 'vee-validate/dist/locale/ru'
import locale from 'element-ui/lib/locale'
import App from './App.vue'

// Plugins
import GlobalComponents from './gloablComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'

// moment, moment-range
import moment from 'moment'
import VueMoment from 'vue-moment'

// router setup
import routes from './routes/routes'

// store
import store from './store'

// library imports
import './assets/sass/paper-dashboard.scss'
import './assets/sass/element_variables.scss'
import './assets/sass/demo.scss'

import sidebarLinks from './sidebarLinks'

require('moment/locale/ru')

// plugin setup
Vue.use(VueRouter)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar, {sidebarLinks: sidebarLinks})
Validator.localize('ru', langValidateRu)
Vue.use(VeeValidate)
locale.use(lang)
Vue.use(VueMoment, { moment })


// configure router
const router = new VueRouter({
	routes, // short for routes: routes
	linkActiveClass: 'active'
})

// load options on store
if (window.options) {
	for (var key in window.options) {
		var item = window.options[key]
		if (item.params) {
			store.commit(item.name, item.value, item.params)
		} else {
			store.commit(item.name, item.value)
		}
	}
}

/* eslint-disable no-new */
new Vue({
	el: '#app',
	render: h => h(App),
	router,
	store
})



// WEBPACK FOOTER //
// ./src/main.js